// AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState(() => {
    const storedToken = localStorage.getItem("authToken");
    return storedToken ? { token: storedToken } : null;
  });

  const login = (data) => {
    localStorage.setItem("authToken", data.token);
    setAuthData(data);
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    setAuthData(null);
  };

  const hasFeature = (featureName) => {
    return authData?.subcription_info?.features?.some(
      (f) => f.name === featureName
    );
  };

  return (
    <AuthContext.Provider value={{ authData, login, logout, hasFeature }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook for easier usage
export const useAuth = () => useContext(AuthContext);
